import { CommerceToolsApi } from '@grandvisionhq/commercetools';

const isLightProductModel = (product)=>'objectID' in product
;
const isContactLenses = (productType)=>CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType)
;

export { isContactLenses, isLightProductModel };
//# sourceMappingURL=types.js.map
